import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import Apis from '@/Apis/_'

type Mode = 'CREATE' | 'EDIT'

type SetSuporteModal = {
  name: string,
  value: boolean,
}

type SuporteModal = {
  motivoCancelamento: boolean,
}

interface MotivoCancelamento {
  id: string,
  descricao: string,
  hisTipo?: string,
  hospitalId: string,
  hisId?: string,
  medicoVisualizar?: boolean,
  etapa: string | null,
  status: 'Ativo' | 'Removido',
}

@Module({ namespaced: true, name: 'SuporteMotivosCancelamentoStore' })
export default class SuporteMotivosCancelamentoStore extends VuexModule {
  public hospitalId: string = ''
  public searchMotivoCancelamento: string = ''

  public mode: Mode = 'CREATE'

  public modal: SuporteModal = {
    motivoCancelamento: false,
  }

  @Mutation
  setSearchMotivoCancelamento(val: string) {
    this.searchMotivoCancelamento = val
  }

  @Mutation
  clearSearchMotivoCancelamento() {
    this.searchMotivoCancelamento = ''
  }

  @Mutation
  setModal(modal: SetSuporteModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  @Mutation
  setMode(param: any) {
    this.mode = param.mode
  }

  /** Motivo de cancelamento */
  private motivoCancelamentoDefault: MotivoCancelamento = {
    id: '',
    descricao: '',
    hisTipo: '',
    hospitalId: this.hospitalId,
    hisId: '',
    medicoVisualizar: false,
    etapa: null,
    status: 'Ativo',
  }

  public motivoCancelamento: MotivoCancelamento = { ...this.motivoCancelamentoDefault }
  public motivosCancelamentoDefault: MotivoCancelamento[] = []
  public motivosCancelamento: MotivoCancelamento[] = [...this.motivosCancelamentoDefault]

  @Mutation
  setMotivosCancelamento(value: MotivoCancelamento[]) {
    this.motivosCancelamento = value
  }

  @Mutation
  clearMotivosCancelamento() {
    this.motivosCancelamento = [...this.motivosCancelamentoDefault]
  }

  @Mutation
  setMotivoCancelamento(value: MotivoCancelamento) {
    this.motivoCancelamento = value
  }

  @Mutation
  clearMotivoCancelamento() {
    this.motivoCancelamento = { ...this.motivoCancelamentoDefault }
  }

  @Action
  async getMotivosCancelamentoByHospitalId() {
    try {
      const request = await Apis.Agendamento.SuporteApi.getMotivosCancelamentoByHospitalId(this.hospitalId)
      if (request.success) this.context.commit('setMotivosCancelamento', request.data as MotivoCancelamento[] || [])
      return request
    } catch (error) {
      this.context.commit('setMotivosCancelamento', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertMotivoCancelamentoByHospital() {
    const params: MotivoCancelamento = this.motivoCancelamento
    Object.entries(params).forEach(([key, value]) => {
      // @ts-ignore
      if (['', null, undefined].includes(value)) delete params[key]
    })

    if (['', null, undefined].includes(params.hospitalId)) params.hospitalId = this.hospitalId

    const request = await Apis.Agendamento.SuporteApi.upsertMotivoCancelamentoByHospital({ ...params })
    return request
  }
}
